import React from 'react'

import garbarnia from './img/garbarnia.jpg'


function opisWisla() {
  return (
    <div className='opis-container'>
      <div className='opis-header'>
        
        <h1>Wieczysta - Grębałowianka</h1> 
        
       
      </div>

      <div className='opis-info'>
          <p>
          6 kolejka I ligi oldboyów Kraków <br></br>

Wieczysta Kraków -Grębałowianka Kraków 2:2 (1:0)<br></br>
Bramki dla Gręby: 1:2 Cecuga 
                                   2:2 Strojek R as. Oleś  <br></br>
Skład Grębałowianki: Nowak - Dominik, Rutka, Ochlust ,Korcala, Wierzbinski, Strojek G, Karaś, Oleś, Cecuga, Strojek R, Mucharski, Talaga, Zięba, Grzywa, Towarek <br></br>
Trener Bernard Łach 
Kapitan Piotr Kokosza <br></br>
Wieczorny mecz z beniaminkiem Wieczystą Kraków zapowiadał się bardzo emocjonująco gdyż gospodarze ostatnie 2 mecze przegrali u siebie bardzo nieznacznie z Wisłą Kraków i Hutnikiem Kraków. Zanim o przebiegu meczu to kilka słów odnośnie murawy bocznego boiska drużyny z Chałupnika. Grając w oldboyach gramy dla przyjemności i pasji zważając na zdrowie oczywiście. Niestety ta murawa nie spełniała nawet warunków drużyn z najniższych klas rozrywkowych. Gra w piłkę była bardzo utrudniona patrząc na nierówności jak i dużo zalegającego piasku. Ale do meczu. Gospodarze od początku próbowali narzucić swój styl gry i udało się im objąć prowadzenie po ładnej klepce i wyjciu zawodnika sam na sam. Prowadzenie Wieczystej. Goście kontratakowali a swoich akcji bramkowych nie wykorzystali dwukrotnie Cecuga jak i Mucharski. 
Po zmianie stron gospodarze strzelili drugą bramkę i prowadząc 2:0 spoczeli na laurach a goście od tego momentu zaczęli grać zdecydowanie odważniej do przodu czego efektem były sytuacje bramkowe. Ładną akcję solową wykonał Cecuga i bramka na 1:2 dał sygnał i bodziec do walki wszystkim zawadnikom. Kolejne akcje przynosiły gościom sytuacje strzeleckie a po jednej z nich Strojek R pięknym strzałem głową po asyście Olesia dał Grębie wynik remisowy. Pod koniec spotkania obie drużyny miały jeszcze swoje sytuacje ale wynik nie uległ zmianie. Remis 2:2 odzwierciedla przebieg meczu. Bardzo cenny remis na trudniej murawie który bardzo szanujemy.
Już za tydzień mecz z Garbarnią Kraków przy Grebalowskiej zapraszamy. 
Brawa 👏dla całej drużyny za walkę i determinację do końca. 
Pozdrawiam Piotr Grzywa 😉👌⚽
          
          </p>

        <img src={garbarnia} alt='gre-garb'></img>
        
        
       
      </div>
        
        </div>
  )
}

export default opisWisla